



































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// Types
import { ICustomFieldSelectOption } from "@/models/brands";

@Component
export default class CustomFieldsOptionsList extends Vue {
  @Prop({ required: true })
  private isProcessing!: boolean;

  @Prop({ required: true })
  private form!: any;

  private counter = 1;

  private sortableOptions: {
    chosenClass: string;
    handle: string;
  } = {
    chosenClass: "is-selected",
    handle: ".drag-and-drop"
  };

  private addNewOption() {
    if (!this.isEmptyOption) {
      this.form.values.push({
        label: ""
      });

      this.$nextTick(() => {
        // @ts-ignore
        this.$refs[`option_${this.form.values.length - 1}`].focus();
      });
    }
  }

  private removeOption(index: number) {
    this.form.values.splice(index, 1);
  }

  private addSelectOption(option: ICustomFieldSelectOption) {
    this.form.values.push(option);
  }

  private onDragDrop() {
    this.counter++;
    this.$emit("formValuesChanged", this.form.values);
  }

  private get isEmptyOption() {
    return !!this.$_.find(this.form.values, row => {
      return this.$_.isEmpty(row.label);
    });
  }
}
